var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2292 19.2074C20.2289 19.76 20.0091 20.2898 19.6182 20.6803C19.2273 21.0708 18.6973 21.29 18.1448 21.2897C17.5923 21.2894 17.0625 21.0697 16.672 20.6788C16.2815 20.2879 16.0622 19.7579 16.0625 19.2053C16.0628 18.6528 16.2825 18.123 16.6734 17.7325C17.0643 17.342 17.5943 17.1228 18.1469 17.123C18.6994 17.1233 19.2292 17.3431 19.6197 17.734C20.0102 18.1249 20.2294 18.6549 20.2292 19.2074ZM20.2917 22.8324H16.125V35.8741H20.2917V22.8324ZM26.875 22.8324H22.7292V35.8741H26.8333V29.0303C26.8333 25.2178 31.8021 24.8637 31.8021 29.0303V35.8741H35.9167V27.6137C35.9167 21.1866 28.5625 21.4262 26.8333 24.5824L26.875 22.8324Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeed);
export default __webpack_public_path__ + "static/media/indeed.3ab257186d8a8da4dcb3608c8f7c4edf.svg";
export { ForwardRef as ReactComponent };